import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for user data in localStorage on initial load
    const customerData = localStorage.getItem('customer');
    const authToken = localStorage.getItem('authToken');
    
    if (customerData && authToken) {
      try {
        const parsedUser = JSON.parse(customerData);
        setCurrentUser(parsedUser);
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.removeItem('customer');
        localStorage.removeItem('authToken');
        localStorage.removeItem('accessToken');
      }
    }
    setLoading(false);
  }, []);

  // When the API layer wipes an invalid/expired session (e.g. a 401 whose
  // refresh failed), reflect it in the UI right away so we don't keep showing a
  // cached name/avatar while every authed call 401s.
  useEffect(() => {
    const onCleared = () => setCurrentUser(null);
    window.addEventListener('stylon:auth-cleared', onCleared);
    return () => window.removeEventListener('stylon:auth-cleared', onCleared);
  }, []);

  const login = (userData) => {
    setCurrentUser(userData);
    localStorage.setItem('customer', JSON.stringify(userData));
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem('customer');
    localStorage.removeItem('authToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('customerId');
  };

  const value = {
    currentUser,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext; 